<template>
  <router-view :key="$route.fullPath" />
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'

useHead({ title: 'Customer' })
const $route = useRoute()
</script>
